import { render, staticRenderFns } from "./SidebarGoddess.vue?vue&type=template&id=1625fd53&scoped=true"
import script from "./SidebarGoddess.vue?vue&type=script&lang=js"
export * from "./SidebarGoddess.vue?vue&type=script&lang=js"
import style0 from "./SidebarGoddess.vue?vue&type=style&index=0&id=1625fd53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1625fd53",
  null
  
)

export default component.exports